import { useLayoutEffect, useRef } from 'react';

/**
 * A ref that always holds the latest `value`, for reads outside render: an
 * unmount cleanup with empty deps, a listener an effect sets up once, a
 * callback handed out before the value existed. Updated in a layout effect,
 * not during render — React forbids touching refs while rendering — so every
 * read that happens after the commit sees the committed value.
 */
export function useLatest<T>(value: T): { readonly current: T } {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
